import Accordion from "./Classes/Accordion";
import { Navigation, Pagination, Autoplay, EffectCards } from "swiper/modules";
import Swiper from "swiper";
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import CustomSwiper from "./Classes/CustomSwiper";
import LottieAutoplay from "./Classes/LottieAutoplay";
import SlideBackgroundVideo from "./Classes/SlideBackgroundVideo";
import SliderViewportScaler from "./Classes/SliderViewportScaler";


window.addEventListener("page_event_load", () => {
  new Accordion({
    accordions: '.lc-accordion__inner-head',
    pxCorrectionMobile: 110,
    pxCorrectionDesktop: 105,
    mobileBreakpoint: 1025
  });

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

  new CustomSwiper();
  new LottieAutoplay();
  new SlideBackgroundVideo();
  new SliderViewportScaler();
});


window.addEventListener('note_event_load', evt => {
  // console.log("note loaded event");
  document.body.classList.add("note-open");

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });
});


window.addEventListener('note_unloaded', evt => {
  //console.log("note unloaded event");
  document.body.classList.remove("note-open");
});
